export const joinCallbacks = <C extends (...args: any[]) => void>(...callbacks: Array<C | undefined | null>) => {
    return (...args: Parameters<C>) => {
        for (const cb of callbacks) cb?.(...args);
    };
};
